module.exports = __webpack_public_path__ + "img/login_text_bg.7f362524.png";